import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "book-reading-nav" }
const _hoisted_2 = { class: "book-reading-nav__container" }
const _hoisted_3 = { class: "book-reading-nav__name book-reading-nav__prev-name" }
const _hoisted_4 = { class: "book-reading-nav__container" }
const _hoisted_5 = { class: "book-reading-nav__name book-reading-nav__next-name" }
const _hoisted_6 = { class: "book-reading-nav__name book-reading-nav__next-name" }

import { DocView } from '@/models/doc'


export default /*@__PURE__*/_defineComponent({
  __name: 'PrevNext',
  props: {
    doc: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.doc.prevLink)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            replace: "",
            to: __props.doc.prevLink.route,
            class: "book-reading-nav__prev-box"
          }, {
            default: _withCtx(() => [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "book-reading-nav__link" }, [
                _createElementVNode("span", { class: "book-reading-nav__icon iconfont iprev" }),
                _createTextVNode("Previous ")
              ], -1)),
              _createElementVNode("p", _hoisted_3, _toDisplayString(__props.doc.prevLink.title), 1)
            ]),
            _: 1
          }, 8, ["to"]))
        : (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            replace: "",
            to: __props.doc.previewLink,
            class: "book-reading-nav__prev-box"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createElementVNode("div", { class: "book-reading-nav__link" }, [
                _createElementVNode("span", { class: "book-reading-nav__icon iconfont iprev" }),
                _createTextVNode("Back ")
              ], -1),
              _createElementVNode("p", { class: "book-reading-nav__name book-reading-nav__prev-name" }, " Back to Preview page ", -1)
            ]))]),
            _: 1
          }, 8, ["to"]))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (__props.doc.nextLink)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            replace: "",
            to: __props.doc.nextLink.route,
            class: "book-reading-nav__next-box"
          }, {
            default: _withCtx(() => [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "book-reading-nav__link book-reading-nav__next" }, [
                _createTextVNode(" Next"),
                _createElementVNode("span", { class: "book-reading-nav__icon iconfont inext" })
              ], -1)),
              _createElementVNode("p", _hoisted_5, _toDisplayString(__props.doc.nextLink.title), 1)
            ]),
            _: 1
          }, 8, ["to"]))
        : (_openBlock(), _createElementBlock("a", {
            key: 1,
            class: "book-reading-nav__next-box",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.doc.doneClick()))
          }, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "book-reading-nav__link book-reading-nav__next" }, [
              _createTextVNode(" Done"),
              _createElementVNode("span", { class: "book-reading-nav__icon iconfont inext" })
            ], -1)),
            _createElementVNode("p", _hoisted_6, _toDisplayString(__props.doc.doneText), 1)
          ]))
    ])
  ]))
}
}

})